var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import tokens from '@gympass/yoga-tokens';
import { css } from 'styled-components';
import hide from './hide';
var breakpoints = tokens.breakpoints;
var media = {
  not: {}
};
export var not = function not(isNot) {
  return isNot ? 'not all and ' : '';
};
var availableBreakpoints = Object.keys(breakpoints);

var getRange = function getRange(width, range) {
  try {
    if (Array.isArray(width)) {
      var _width = _slicedToArray(width, 2),
          min = _width[0],
          max = _width[1];

      var minBreakpoint = breakpoints[min].width,
          maxBreakpoint = breakpoints[max].width;
      return "(min-width: ".concat(minBreakpoint, "px) and (max-width: ").concat(maxBreakpoint, "px)");
    }

    return "(".concat(range, "-width: ").concat(breakpoints[width].width, "px)");
  } catch (_unused) {
    var msg = "Make sure you've entered the right breakpoints. \n  Your input: ".concat(Array.isArray(width) ? width.join(', ') : width, "\n  Available breakpoints: ").concat(availableBreakpoints.join(', '));
    throw new Error(msg);
  }
};

export var matcher = function matcher(width) {
  var isNot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var range = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'min';
  return function () {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @media ", "", " {\n    ", "\n  }\n"])), not(isNot), getRange(width, range), css.apply(void 0, arguments));
  };
};
availableBreakpoints.forEach(function (breakpoint) {
  media[breakpoint] = matcher(breakpoint);
  media.not[breakpoint] = matcher(breakpoint, true);
});

media.max = function (width) {
  return matcher(width, false, 'max');
};

media.not.max = function (width) {
  return matcher(width, true, 'max');
};

media.between = function (min, max) {
  return matcher([min, max], false, 'max');
};

media.not.between = function (min, max) {
  return matcher([min, max], true, 'max');
};

media.hide = hide();
media.not.hide = hide(true);
export default media;